import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import avatar from '../../Pics/avatar.jpg'

import SpecificComponent from '../SpecificComponent'
import { Fab, FormControl, InputLabel, Select, MenuItem, Input, Grid, Checkbox, Avatar } from '@material-ui/core';
import Utils from '../../providers/Utils';
import PropTypes from 'prop-types';
import Ws from '../../providers/Ws';
import OpenAddFisaPostului from './OpenAddFisaPostului';
import OpenAddCV from './OpenAddCV';


export default class CosturiUpdate extends SpecificComponent {

    constructor(props) {
        super(props)
        this.state = {

        }
    }

    //fisaPost adresaMedia + /Angajati/FisePost


    getLitereAvatar = (tx) => {

        if (tx !== null) {

            return tx.substring(0, 1).toUpperCase()
        }
    }





    render() {
        return (
            <div>
                <Dialog
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    fullWidth={true}
                    maxWidth={'md'}
                    style={{
                        zIndex: 5000,
                    }}
                >

                    <DialogActions>
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>clear</i>
                        </Fab>
                    </DialogActions>
                    <div style={{ width: 'fit-content', height: '100%', position: 'relative', cursor: 'pointer', marginLeft: 10 }}>

                        <span className='pm-title'>{this.props.limba.bugete.adaugatEditat}: </span>
                        {
                            this.props.objUser.poza &&
                            <div
                                className='pm-angajati-picture'
                                style={{ backgroundImage: `url('${new Ws().adresaMedia + '/Angajati/' + this.props.objUser.poza}')` }}>

                            </div>
                        }
                        {!this.props.objUser.poza &&
                            <Avatar style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(this.props.objUser.nume + ' ')} </Avatar>
                        }
                        <span className='pm-task-change-user'>{this.props.objUser.nume}</span>

                    </div>
                    <h2 style={{ marginBottom: 5 }} className="pm-title">{this.props.cost.nume}</h2>



                    <DialogContent style={{ width: '90%', margin: 'auto', overflow: 'hidden' }}>
                        <Grid style={{ width: '90%', margin: 'auto' }} container >


                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.settings.valoare}
                                    value={this.props.cost.valoare || ''}
                                    onChange={this.props.changeCost('valoare')}
                                    margin="normal"
                                    type='text'
                                />

                            </Grid>
                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.settings.dataCost}
                                    value={this.props.cost.data_costului || ''}
                                    onChange={this.props.changeCost('data_costului')}
                                    margin="normal"
                                    type='date'
                                />

                            </Grid>
                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <TextField
                                    disabled={true}
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.bugete.adaugatLa}
                                    value={this.props.cost.adaugat_la || ''}
                                    margin="normal"
                                    type='date'
                                />

                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.settings.note}
                                    value={this.props.cost.note || ''}
                                    onChange={this.props.changeCost('note')}
                                    margin="normal"
                                    multiline
                                />
                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.settings.explicatii}
                                    value={this.props.cost.explicatii || ''}
                                    onChange={this.props.changeCost('explicatii')}
                                    margin="normal"
                                    multiline
                                />
                            </Grid>




                        </Grid>

                    </DialogContent>

                    <DialogActions>

                        <div style={{ margin: 'auto' }}>
                            <Button variant="outlined" onClick={() => { this.props.updateCost(this.props.cost) }} className='pm-save-button'>
                                {this.props.limba.comune.save}
                            </Button>

                            {/* <Button  variant="outlined" style={{marginLeft:10}} onClick={() => { this.props.deleteCost(this.props.cost) }} className='pm-delete-button'>
                            {this.props.limba.comune.sterge}
                        </Button> */}
                        </div>

                    </DialogActions>

                </Dialog>






            </div>

        );
    }


}  // end class

CosturiUpdate.propTypes={
    open:PropTypes.bool,
    dialogClose:PropTypes.func,
    objUser:PropTypes.object,
    limba:PropTypes.object,
    cost:PropTypes.object,
    changeCost:PropTypes.func,
    updateCost:PropTypes.func,
    


}